import * as yup from "yup";
import { DEFAULT_MESSAGES } from "../defaultMessages";

export const createCajaCurricularPciSchema = yup.object({
  caja_curricular_id: yup.mixed().required(DEFAULT_MESSAGES.REQUIRED),
  descripcion: yup.string().required(DEFAULT_MESSAGES.REQUIRED),
  version: yup.string().required(DEFAULT_MESSAGES.REQUIRED),
});
